import React from "react";
import { Link } from "react-router-dom";

const HeroBannerTwelve = () => {
  return (
    <div className="hero-banner-twelve lg-container" id="home">
      <div className="container">
        <div className="row">
          <div className="col-xl-11 col-lg-12 col-md-10 m-auto text-center">
            <h1 className="hero-heading font-gordita" data-aos="fade-up">
              Xác minh danh tính điện tử{" "}
              <span style={{ color: "#0ea5e9" }}>nhanh chóng</span>,{" "}
              <span style={{ color: "#FEDC00" }}>Chính xác</span> và an toàn
            </h1>
            <p
              className="hero-sub-heading"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              Bằng công nghệ trí tuệ nhân tạo tiên tiến của NEO. Giúp tối ưu quy trình làm việc, tuân thủ các quy định KYC/AML và làm hài lòng khách hàng
            </p>
            <div data-aos="fade-up" data-aos-delay="200">
              <Link to="/demo/ekyc" className="get-start-btn">
                Trải nghiệm eKYC{" "}
                <i className="fa fa-angle-right ms-1" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>

        <div className="screen-holder" data-aos="fade-up">
          <img
            src="images/assets/screen_32.svg"
            alt="screen"
            className="img-meta"
          />
          <img
            src="images/assets/screen_33.svg"
            alt="screen"
            className="shapes screen-one"
          />
          <img
            src="images/assets/screen_34.svg"
            alt="screen"
            className="shapes screen-two"
          />
          <img
            src="images/shape/230.svg"
            alt="screen"
            className="shapes shape-one"
          />
          <img
            src="images/shape/231.svg"
            alt="screen"
            className="shapes shape-two"
          />
          {/* </div> <!-- /.screen-holder --> */}
        </div>
        <img
          src="images/shape/232.svg"
          alt="shape"
          className="shapes shape-three"
        />
        <img
          src="images/shape/233.svg"
          alt="shape"
          className="shapes shape-four"
        />
        <img
          src="images/shape/234.svg"
          alt="shape"
          className="shapes shape-five"
        />
        <img
          src="images/shape/235.svg"
          alt="shape"
          className="shapes shape-six"
        />
        <img
          src="images/shape/236.svg"
          alt="shape"
          className="shapes shape-seven"
        />
        <img
          src="images/shape/232.svg"
          alt="shape"
          className="shapes shape-eight"
        />
      </div>
    </div>
    // /.hero-banner-twelve
  );
};

export default HeroBannerTwelve;
